import { render, staticRenderFns } from "./AppSelectPais.vue?vue&type=template&id=3067b3a9&"
import script from "./AppSelectPais.vue?vue&type=script&lang=js&"
export * from "./AppSelectPais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports